"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDefinition = void 0;
const MessageDefinition_1 = __importDefault(require("./MessageDefinition"));
exports.MessageDefinition = MessageDefinition_1.default;
//# sourceMappingURL=index.js.map